<template>
  <div>
    <div class="filters">
      <el-select
          @change="loadVisitList(1)"
          class="filters__department"
          v-model="search.departmentId"
          v-loading="loadDepartment"
          placeholder="Название учреждения"
          name="department"
      >
        <el-option
            v-for="item in departmentList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
        ></el-option>
      </el-select>
      <el-input
          @change="loadVisitList(1)"
          name="phone"
          ref="phone"
          v-model="search.phone"
          v-mask="'+7-xxx-xxx-##-##'"
          placeholder="Номер телефона (4 цифры)..."
          auto-complete="off"
          class="filters__phone"
          suffix-icon="el-icon-search"
          clearable
      ></el-input>

<!--      <el-input-->
<!--          @change="loadVisitList(1)"-->
<!--          v-model="search.id"-->
<!--          class="filters__id"-->
<!--          placeholder="ID..."-->
<!--          auto-complete="off"-->
<!--          suffix-icon="el-icon-search"-->
<!--          clearable-->
<!--      ></el-input>-->
<!--      <el-select-->
<!--          @change="loadVisitList(1)"-->
<!--          class="filters__select"-->
<!--          v-model="filters.time"-->
<!--          placeholder="Сортировка"-->
<!--          name="department"-->
<!--      >-->
<!--        <el-option-->
<!--            v-for="item in timesList"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--        ></el-option>-->
<!--      </el-select>-->
      <el-date-picker
          v-model="search.date"
          class="client-data__input"
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          type="date"
      />
      <el-select
          class="filters__status"
          @change="loadVisitList(1)"
          v-model="search.inspectionStatus"
          placeholder="Статус визита"
      >
        <el-option
            v-for="item in inspectionStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <el-radio-group v-model="activeVisitTab" @change="setVisitTab" class="visit-tabs ellipse-radio">
      <el-radio-button label="list">Доступные визиты</el-radio-button>
      <el-radio-button label="history">Просмотренные визиты</el-radio-button>
    </el-radio-group>

    <div v-loading="loading">
      <div class="visits" v-if="isShowVisit">

        <user-list @sort-change="editSort"  :visits="visitsList" :history="activeVisitTab === 'history'" @openUser="goVisit"/>

        <el-pagination
            v-if="showPagination"
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagination.per_page"
            :total="pagination.total"
            :current-page="pagination.current_page"
            @current-change="loadVisitList"
        />
      </div>
      <el-alert
          v-else
          :closable="false"
          title="Отсутствует список найденных визитов"
          type="info">
      </el-alert>

    </div>


  </div>
</template>

<script>
import Vue from "vue"
import VueMask from "v-mask"
import {mapActions} from "vuex"
import UserList from "@/components/elements/UserVisitList/UserList"

Vue.use(VueMask);

export default {
  name: "VisitsList",
  data: function () {
    return {
      visitsList: null,
      pagination: null,
      modalDevice: null,
      visibleCloseSessionModal: false,
      loadTable: false,
      loading: false,
      loadDepartment: false,
      activeVisitTab: 'list',
      inspectionStatus: [
        {
          value: null,
          label: "Все",
        },
        {
          value: "draft",
          label: "Черновик",
        },
        {
          value: "archive",
          label: "Отправлен",
        },
        {
          value: "new",
          label: "Входящие",
        },
      ],
      timesList: [
        {
          value: 'desc',
          label: "Выберите статус...",
        },
        {
          value: 'asc',
          label: "Старые",
        }
      ],
      search: {
        departmentId: 0,
        inspectionStatus: null,
        phone: null,
        id: null,
      },
      filters: {
        time: 'desc'
      },
      departmentList: {},
      value: "",
    };
  },
  components: {UserList},
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page;
      } else return false;
    },
    isShowVisit() {
      if (this.visitsList) {
        return (this.visitsList.length != 0)
      } else return false
    }
  },
  created() {
    this.loadVisitList(1)
    this.getDepartments()
    this.setStageVisit(0)
  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
    }),
    setVisitTab() {
      this.loadVisitList()
    },
    editSort(column) {

      this.loadVisitList(1, {
        order: column.order,
        prop: column.prop
      })

    },
    loadVisitList(page = 1, sort = {}) {
      this.loading = true

      let search = [];
      if (this.search.inspectionStatus)
        search.push("inspection_status:" + this.search.inspectionStatus);
      if (this.search.departmentId)
        search.push("department_id:" + this.search.departmentId);
      if (this.search.id)
        search.push("user_id:" + this.search.id);

      let params = {
        params: {
          page,
          sortedBy: sort.order === 'ascending' ? 'asc' : sort.order === 'descending' ? 'desc' : null,
          orderBy: sort.prop  ? sort.prop : null,
          dateTime: this.search.date,
          // all: true,
          // search: search.join(";"),
          searchJoin:
              search.length > 1
                  ? "and"
                  : null,
          find: this.search.phone
              ? this.search.phone.replace("+7", "").replace(/[^\d]/g, "")
              : null,
        },
      };

      this.$api.visit
          .getList(this.activeVisitTab, params)
          .then((response) => {
            this.visitsList = response.data.data;

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
            else this.pagination = null

          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            });
          })
          .finally(() => {
            this.loading = false
          })
    },
    goVisit(visit) {
      this.$router.push({name: "visit.item", params: {id: visit.id, goDevice: true}})
    },
    closeSession() {
      this.visibleCloseSessionModal = !!1
    },
    editPagination(id) {
      console.log(id)
    },
    getDepartments() {
      this.loadDepartment = true

      this.$api.department
          .getList("lite")
          .then((response) => {

            this.departmentList = [
              ...[{id: 0, title: "Все"}],
              ...response.data,
            ]

          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            this.loadDepartment = false
          })
    },
  },
};
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  align-content: center;
  gap: 12px;

  &__phone {
    width: 230px;
  }

  &__id {
    width: 80px;
  }

  &__department {
    width: 140px;
  }

  &__status {
    width: 110px;
  }

  &__select {
    width: 110px;
  }
}

.visit-tabs {
  margin: 10px 0;

  /deep/ .el-tabs__item.is-active {
    color: #111;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #111;
  }

  /deep/ .el-tabs__item {
    color: #8E8E93;
  }


}

.page-buttons {
  margin: 25px auto;
  text-align: center;
}

.doctor {
  &__ava {
    width: 100px;
  }

  &__name {
    font-size: 16px;
  }

  &__contact {
    font-size: 13px;
  }

  &__gender {
    font-size: 12px;
    margin: 0;
  }
}

.pagination {
  margin-top: 10px;
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}
</style>